// @flow
import actions from "./actions";

const setDestInputAddress = actions.setDestInputAddress;

export default {
    setDestInputAddress,
};


// WEBPACK FOOTER //
// ./src/Store/Ducks/DestAutocomplete/operations.js